import Vue from 'vue';
import Vuex from 'vuex';

import news from './modules/news/news.js'
import goTop from './modules/goTop/goTop.js'
import toTab from './modules/toTab/toTab.js'

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

// 创建并暴露store
export default new Vuex.Store({
    modules: {
        news,
        goTop,
        toTab
    },
    // strict: debug
});